import {Component, Input, ViewEncapsulation, ChangeDetectionStrategy} from '@angular/core';
import {IBlockSignalConfig} from './block-signal.data';

@Component({
    selector: 'app-block-signal',
    templateUrl: './block-signal.component.html',
    styleUrls: ['./block-signal.component.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class BlockSignalComponent {

    @Input() config: IBlockSignalConfig;

}
